import React from 'react'
import { useIntl } from 'react-intl'

import QuoteSectionBodyTableHeader from '../quote-section-body-table-header/QuoteSectionBodyTableHeader'
import QuoteSectionBodyTableRow from '../quote-section-body-table-row/QuoteSectionBodyTableRow'
import { UpdateQuoteTableRowTypeEnum } from '../quote-section-body-table-row/utils/utils'
import { useGetFormattedClientPricingItems } from '../useGetFormattedClientPricingItems'
import { QuoteSectionClientProposalPlanningItemByDateFragment } from '../../../../../../../../../lib/graphql'
import { useDateFormatter } from '../../../../../../../../../lib/hooks'
import {
  Table,
  TableBody,
} from '../../../../../../../../../shadcn/components/ui/table'
import { useVatStatus } from '../../../../../../../../contexts/vat-status-context/useVatStatus'

const QuoteSectionBodyTablePlanning = ({
  planningItemSections,
}: {
  planningItemSections: QuoteSectionClientProposalPlanningItemByDateFragment[]
}) => {
  const { vatStatus } = useVatStatus()
  const dateFormatter = useDateFormatter()
  const intl = useIntl()

  const { getFormattedPlanningItems } = useGetFormattedClientPricingItems()

  return (
    <Table>
      {planningItemSections.map((section) => {
        const formattedItems = getFormattedPlanningItems({
          planningItems: section.planningItems,
        })
        return (
          <>
            <QuoteSectionBodyTableHeader
              hasActions={false}
              label={
                section.date
                  ? dateFormatter.format({
                      date: section.date,
                      formatString: 'fullDate',
                    })
                  : intl.formatMessage({
                      id: 'ui.ProposalDetailsPlanning.dateNotSpecified',
                      defaultMessage: 'Date non spécifiée',
                    })
              }
              vatStatus={vatStatus}
              isDragDisabled={true}
            />
            <TableBody>
              {formattedItems.map((item) => (
                <QuoteSectionBodyTableRow
                  key={item.id}
                  type={UpdateQuoteTableRowTypeEnum.DEFAULT}
                  {...item}
                  actions={[]}
                  isDragDisabled={true}
                />
              ))}
            </TableBody>
          </>
        )
      })}
    </Table>
  )
}

export default QuoteSectionBodyTablePlanning
